import React from 'react';

interface Props {
  children: React.ReactNode;
  excludeClickOnRef?: React.RefObject<HTMLElement>;
  onClickAway: () => void;
}

const ClickAwayListener = (props: Props) => {
  const nodeRef = React.useRef<HTMLDivElement>(null);

  const handleClickAway = React.useCallback(
    (e: MouseEvent) => {
      // Click from inside children?
      if (nodeRef.current?.contains(e.target as Node)) {
        return;
      }

      // Click from inside additional element?
      if (props.excludeClickOnRef?.current?.contains(e.target as Node)) {
        return;
      }

      // Click was outside.
      props.onClickAway();
    },
    [props],
  );

  React.useEffect(() => {
    window.addEventListener('click', handleClickAway, true);

    return () => {
      window.removeEventListener('click', handleClickAway, true);
    };
  }, [handleClickAway]);

  return <div ref={nodeRef}>{props.children}</div>;
};

export { ClickAwayListener };
